import ErrorBoundary from 'components/ErrorBoundary'
import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import Arrow from "assets/icon/Left-Chevron.svg";

const AccmulatorDetails = (props) => {
    const {
        rowData,setACCflag,  viewConfig,
        setviewConfig,setCElevelflag,CElevelflag,setLoading,
        loading,} = props;
        console.log(rowData,"rowdata")
    const handelCEhistory = () => {
        setACCflag(false);
        setviewConfig(false);
        setCElevelflag(false)
      };
  return (
    <div>
         <Card className='border-0 shadow-top mt-3'>
    <CardBody className='section-devider-border'>
        <ErrorBoundary>
            <Row>
            <div className="d-flex align-items-center">
            <h4 className='f-16 text-primary font-weight-700'style={{ cursor: "pointer" }}
                  onClick={handelCEhistory}>
                    <span
                    style={{
                      paddingRight: "5px",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <img style={{ width: "8px" }} src={Arrow} />
                  </span>{" "}
                  Accumulator Details
            </h4>
            </div>
          
                <Col md="3">
                    <p className="m-0 f-14 mt-3">Accumulator Name :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.ceName}</p>
                </Col>
                <Col md="3">
                    <p className="m-0 f-14 mt-3">OPA Code :</p>
                    {/* <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.opaCode}</p> */}
                    <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.opaCode}</p>

                </Col>
                <Col md="3">
                    <p className="m-0 f-14 mt-3">Contact Person :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.contactPerson}</p>
                </Col>
                
                <Col md="3">
                    <p className="m-0 f-14 mt-3">Phone No :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.phone}</p>
                </Col>
                <Col md="3">
                    <p className="m-0 f-14 mt-3">Email Id :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.emailID}</p>
                </Col>
                <Col md="3">
                    <p className="m-0 f-14 mt-3">City :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.cityName}</p>
                </Col>
                <Col md="3">
                    <p className="m-0 f-14 mt-3">State :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.stateName}</p>
                </Col>

            </Row>
          
         
            

        </ErrorBoundary>

    </CardBody>
  
   

</Card>
    </div>
  )
}

export default AccmulatorDetails